// import { Section404 } from "@404pagez/react";

export default function Page404() {
    
    return (
          <div className={`min-h-screen flex items-center justify-center px-4 transition-colors duration-300
                       bg-gray-50`}>
                        <div className="max-w-2xl w-full text-center">
                            {/* 404 Numarası */}
                            <div className="relative">
                                <h1 className={`text-9xl font-bold mb-4 transition-colors duration-300 text-gray-200`}>
                                    404
                                </h1>
                                <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-6xl font-bold transition-colors duration-300 text-blue-600`}>
                                    404
                                </div>
                            </div>
            
                            {/* Başlık ve Açıklama */}
                            <h2 className={`text-3xl font-bold mb-4 transition-colors duration-300 text-gray-900`}>
                                Page Not Found
                            </h2>
                            <p className={`text-lg mb-8 transition-colors duration-300 text-gray-600`}>
                                The page you are looking for doesn't exist or has been moved. Please check the URL or return to the homepage.
                            </p>
            
                            {/* Butonlar */}
                            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                                {/* <button className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
                                    isDark 
                                        ? 'bg-blue-600 hover:bg-blue-700 text-white' 
                                        : 'bg-blue-600 hover:bg-blue-700 text-white'
                                }`}>
                                    <Home size={20} />
                                    Back to Home
                                </button>
                                
                                <button className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
                                    isDark 
                                        ? 'bg-gray-800 hover:bg-gray-700 text-white border border-gray-700' 
                                        : 'bg-white hover:bg-gray-100 text-gray-900 border border-gray-300'
                                }`}>
                                    <Search size={20} />
                                    Search
                                </button> */}
                            </div>
            
                            {/* Geri Dön Linki */}
                            {/* <button className={`flex items-center gap-2 mx-auto mt-8 transition-colors duration-300 ${
                                isDark 
                                    ? 'text-gray-400 hover:text-gray-300' 
                                    : 'text-gray-600 hover:text-gray-800'
                            }`}>
                                <ArrowLeft size={18} />
                                Go Back
                            </button>
             */}
                            {/* Dekoratif Elemanlar */}
                            <div className="mt-12 flex justify-center gap-2">
                                {[...Array(3)].map((_, i) => (
                                    <div
                                        key={i}
                                        className={`w-2 h-2 rounded-full transition-colors duration-300 bg-gray-300`}
                                        style={{
                                            animation: `pulse 1.5s ease-in-out ${i * 0.2}s infinite`
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
            
                        <style>{`
                            @keyframes pulse {
                                0%, 100% {
                                    opacity: 0.3;
                                    transform: scale(1);
                                }
                                50% {
                                    opacity: 1;
                                    transform: scale(1.2);
                                }
                            }
                        `}</style>
                    </div>
    )
}